import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table table-hover"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  style: {"width":"1px"},
  class: "pr-1"
}
const _hoisted_4 = {
  style: {"width":"1px"},
  class: "pr-0 pl-0"
}
const _hoisted_5 = { class: "pl-2" }
const _hoisted_6 = {
  style: {"width":"70px"},
  class: "text-right"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-center text-muted" }
const _hoisted_9 = { class: "text-left" }

import {VirtualOperatorConfigInterface} from "~/cabinet/vue/client/online/config/operators/virtual/Interface";
import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import MyIconButton from "~/cabinet/vue/interface/button/MyIconButton.vue";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import {computed, nextTick, Ref, ref} from "vue";
import {useSortable} from "@vueuse/integrations";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import OperatorAvatarConfig from "~/cabinet/vue/client/online/config/operators/OperatorAvatarConfig.vue";
import OperatorCabinetAvatar from "~/cabinet/vue/client/online/config/operators/OperatorCabinetAvatar.vue";
import {NO_AVATAR_PATH} from "~/chat/ts/data/ISiteParams";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import Delay from "~/ts/library/Delay";

interface ResponseInterface {
    virtualOperators: VirtualOperatorConfigInterface[];
}

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "VirtualOperatorConfigDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    virtualOperators: {},
    siteId: {}
  }, {
    "modelValue": {
    type: Boolean,
    required: true
},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

let model = _useModel(__props, "modelValue");

let sortableTbody = ref<HTMLElement>();

let list: Ref<VirtualOperatorConfigInterface[]> = ref([]);

function replaceVirtualOperators(data: ResponseInterface) {
    if (props.virtualOperators) {
        props.virtualOperators.splice(0, props.virtualOperators.length);
        props.virtualOperators.push(...data.virtualOperators);
    }
    list.value = data.virtualOperators;

    setTimeout(() => {
        nextTick(() => {
            useSortable(sortableTbody, list, {
                handle: ".cursor-move",
                onEnd: onSortEnd
            });
        });
    }, 100);
}


let request = (new ReactiveRequest<ResponseInterface>(new LcabApiRequest({
    url: `/api/online/${props.siteId}/config/virtualOperators/getData`
}))).setCallback(replaceVirtualOperators).setErrorCallback(result => {
    result?.showMessageOnError();
    model.value = null;
});


let editDialog = ref<{
    visible: boolean,
    id?: string
}>();

let editDialogRequest = computed(() => (new ReactiveRequest<{
    operator: VirtualOperatorConfigInterface
}>(new LcabApiRequest({
    url: `/api/online/${props.siteId}/config/virtualOperators/getEditDialog`,
    p: {
        id: editDialog.value.id
    }
}))).setErrorCallback(result => {
    result?.showMessageOnError();
    editDialog.value = null;
}));


function openEditDialog(id?: string) {
    editDialog.value = {
        visible: true,
        id
    };
}

async function saveOperator() {
    let result = await (new LcabApiRequest<ResponseInterface & { id: string }>({
        url: `/api/online/${props.siteId}/config/virtualOperators/saveOperator`,
        p: editDialogRequest.value.data.operator
    })).send();
    result.showMessage();
    if (result.isSuccess) {
        replaceVirtualOperators(result.data);
        if (!editDialog.value.id) {
            emits('select', result.data.id);
        }
        editDialog.value = null;
    }
}

function onNewAvatar(operator: VirtualOperatorConfigInterface, value: string) {
    operator.avatar = value;
    operator.newAvatar = true;
}

async function remove(id: string) {
    try {
        await ElConfirm("Вы уверены, что хотите удалить этого виртуального оператора?");
        let result = await LcabApiRequest.save<ResponseInterface>({
            url: `/api/online/${props.siteId}/config/virtualOperators/${id}/deleteOperator`,
        });
        if (result.isSuccess) {
            replaceVirtualOperators(result.data);
        }
    } catch (e) {

    }
}

async function onSortEnd() {
    try {
        await Delay.make(3000, "virtualOperatorSort");
        await LcabApiRequest.fetch({
            url: `/api/online/${props.siteId}/config/virtualOperators/saveSorting`,
            p: {
                idList: list.value.map(item => item.id)
            },
            silent: true
        });
    } catch (e) {

    }

}



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "overflow right full-height-body",
    "body-class": "p-0",
    title: "Виртуальные операторы",
    width: "500px",
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event))
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(ReactiveRequestLoader, { request: _unref(request) }, {
        default: _withCtx(() => [
          (_unref(request).data)
            ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
                _createElementVNode("tbody", {
                  ref_key: "sortableTbody",
                  ref: sortableTbody
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.id,
                      onClick: ($event: any) => (_unref(emits)('select', row.id))
                    }, [
                      _createElementVNode("td", _hoisted_3, [
                        _createVNode(FontAwesomeIcon, {
                          icon: "ellipsis-v",
                          class: "text-muted cursor-move mr-2"
                        })
                      ]),
                      _createElementVNode("td", _hoisted_4, [
                        _createVNode(OperatorCabinetAvatar, {
                          "avatar-url": row.avatar ?? _unref(NO_AVATAR_PATH)
                        }, null, 8, ["avatar-url"])
                      ]),
                      _createElementVNode("td", _hoisted_5, _toDisplayString(row.descr), 1),
                      _createElementVNode("td", _hoisted_6, [
                        _withDirectives(_createVNode(MyIconButton, { edit: "" }, null, 512), [
                          [
                            _directive_on_native,
                            () => openEditDialog(row.id),
                            "click",
                            { stop: true }
                          ]
                        ]),
                        _withDirectives(_createVNode(MyIconButton, { delete: "" }, null, 512), [
                          [
                            _directive_on_native,
                            () => remove(row.id),
                            "click",
                            { stop: true }
                          ]
                        ])
                      ])
                    ], 8, _hoisted_2))
                  }), 128)),
                  (!_unref(list).length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                        _createElementVNode("td", _hoisted_8, [
                          _cache[7] || (_cache[7] = _createElementVNode("p", null, " Пока не добавлено ни одного виртуального оператора. ", -1)),
                          _createElementVNode("p", null, [
                            _createVNode(_component_el_button, {
                              link: "",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (openEditDialog()))
                            }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode(" Добавить ", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 512)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["request"]),
      (_unref(editDialog)?.visible)
        ? (_openBlock(), _createBlock(MyDialog, {
            key: 0,
            visible: _unref(editDialog).visible,
            "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(editDialog).visible) = $event)),
            title: _unref(editDialog).id ? 'Редактирование виртуального оператора' : 'Добавление виртуального оператора',
            width: "500px",
            "apply-disabled": !_unref(editDialogRequest).data,
            "button-text": "Сохранить",
            onApply: saveOperator
          }, {
            default: _withCtx(() => [
              _createVNode(ReactiveRequestLoader, { request: _unref(editDialogRequest) }, {
                default: _withCtx(() => [
                  (_unref(editDialogRequest).data)
                    ? (_openBlock(), _createBlock(_component_el_form, {
                        key: 0,
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "Имя" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(editDialogRequest).data.operator.descr,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(editDialogRequest).data.operator.descr) = $event)),
                                placeholder: "Укажите имя виртуального оператора"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "Аватар" }, {
                            default: _withCtx(() => [
                              _createVNode(OperatorAvatarConfig, {
                                "model-value": _unref(editDialogRequest).data.operator.avatar,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (onNewAvatar(_unref(editDialogRequest).data.operator, $event))),
                                "is-new": _unref(editDialogRequest).data.operator.newAvatar,
                                class: "lh-1"
                              }, null, 8, ["model-value", "is-new"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["request"])
            ]),
            _: 1
          }, 8, ["visible", "title", "apply-disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_unref(list).length)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openEditDialog()))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Создать оператора ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})